export const operators = [
  {
    id: '13',
    name: 'Anex',
    fullname: 'Anex Tour',
    russian: 'Анекс Тур',
  },
  {
    id: '171',
    name: 'Coral Travel (BY)',
    fullname: 'Coral Travel (BY)',
    russian: 'Coral Travel (BY)',
  },
  {
    id: '140',
    name: 'FUN&SUN (TUI) (BY)',
    fullname: 'FUN&SUN (TUI) (BY)',
    russian: 'FUN&SUN (TUI) (BY)',
  },
  {
    id: '90',
    name: 'Kompas (KZ)',
    fullname: 'Kompas (KZ)',
    russian: 'Компас (KZ)',
  },
  {
    id: '12',
    name: 'Pegas',
    fullname: 'Pegas Touristik',
    russian: 'Пегас Туристик',
  },
  {
    id: '23',
    name: 'Russian Express',
    fullname: 'Russian Express',
    russian: 'Русский Экспресс',
  },
  {
    id: '15',
    name: 'TezTour',
    fullname: 'Tez Tour',
    russian: 'Тез Тур',
  },
  {
    id: '138',
    name: 'Time Voyage (BY)',
    fullname: 'Time Voyage (BY)',
    russian: 'Тайм Вояж (BY)',
  },
  {
    id: '175',
    name: 'Vogue Travel (BY)',
    fullname: 'Vogue Travel (BY)',
    russian: 'Vogue Travel (BY)',
  },
  {
    id: '150',
    name: 'АлатанТур (BY)',
    fullname: 'АлатанТур (BY)',
    russian: 'АлатанТур (BY)',
  },
  {
    id: '87',
    name: 'АэроБелСервис (BY)',
    fullname: 'АэроБелСервис (BY)',
    russian: 'АэроБелСервис (BY)',
  },
  {
    id: '136',
    name: 'Аэротрэвел (BY)',
    fullname: 'Аэротрэвел (BY)',
    russian: 'Аэротрэвел (BY)',
  },
  {
    id: '137',
    name: 'Вояжтур (BY)',
    fullname: 'Вояжтур (BY)',
    russian: 'Вояжтур (BY)',
  },
  {
    id: '86',
    name: 'ИНТЕРСИТИ (BY)',
    fullname: 'ИНТЕРСИТИ (BY)',
    russian: 'ИНТЕРСИТИ (BY)',
  },
  {
    id: '88',
    name: 'Ростинг (BY)',
    fullname: 'Ростинг (BY)',
    russian: 'Ростинг (BY)',
  },
  {
    id: '122',
    name: 'Топ Тур (BY)',
    fullname: 'Топ Тур (BY)',
    russian: 'Топ Тур (BY)',
  },
  {
    id: '151',
    name: 'Центркурорт (BY)',
    fullname: 'Центркурорт (BY)',
    russian: 'Центркурорт (BY)',
  },
];

export default operators;
